const article = document.querySelector('.article');

if (article) {
    const articleHeadings = document.querySelectorAll('.article__content .rich-text h2');
    const articleHeadingsList = document.querySelector('.article__toc__list');

    if (articleHeadings.length < 2) return;

    articleHeadings.forEach((heading) => {
        const headingText = heading.innerText;
        const headingId = heading.id;

        const headingItem = document.createElement('li');
        headingItem.classList.add('article__toc__item');

        const headingLink = document.createElement('a');
        headingLink.classList.add('article__toc__link');
        headingLink.setAttribute('href', `#${headingId}`);
        headingLink.innerText = headingText;

        headingItem.appendChild(headingLink);
        articleHeadingsList.appendChild(headingItem);
    });

    window.addEventListener('scroll', () => {
        const articleHeadingsArray = Array.from(articleHeadings);

        articleHeadingsArray.forEach((heading, index) => {
            const headingId = heading.id;
            const headingItem = document.querySelector(`.article__toc__item a[href="#${headingId}"]`);
            const headingItemParent = headingItem.parentNode;

            if (heading.getBoundingClientRect().top < 100) {
                headingItemParent.classList.add('article__toc__item--active');

                const previousHeading = articleHeadingsArray[index - 1];

                if (previousHeading) {
                    const previousHeadingId = previousHeading.id;
                    const previousHeadingItem = document.querySelector(`.article__toc__item a[href="#${previousHeadingId}"]`);
                    const previousHeadingItemParent = previousHeadingItem.parentNode;

                    previousHeadingItemParent.classList.remove('article__toc__item--active');
                    previousHeadingItemParent.classList.add('article__toc__item--finished');
                }
            } else {
                headingItemParent.classList.remove('article__toc__item--active');

                if (heading.getBoundingClientRect().top > 100) {
                    headingItemParent.classList.remove('article__toc__item--finished');
                }
            }
        });
    });
}
